<template>
  <div class="page-content">
    <!-- <p class="newMine_pageTitle">站内消息</p> -->
     <p class="newMine_pageTitle newMine_pageTitleb m-b10">
      <span class="newMine_pageTitles">学习提醒</span>
    </p>
    <div class="newMine_content">
      <div class="newMine_list d-flex d-flex-between" v-for="(item, index) in pageData.records" :key="index"
        @click="toDetails(item)">
        <p class="list_title">{{ item.content }}</p>
        <p class="list_time">{{ item.createTime }}</p>
      </div>
      <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageData.current" :page-sizes="[5, 10, 20, 50]" :page-size="pageData.size"
        layout="total, sizes, prev, pager, next, jumper" :total="pageData.total">
      </el-pagination> -->
    </div>
    <div class="pagination" style="display: flex ; justify-content: center;margin-bottom: 15px;">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="pageData.size"
        :total="pageData.total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  components: {
  },
  name: "msg",
  data() {
    return {
      loading: false,
      pageData: {
        current: 1,
        size: 10,
        total: 0,
        records:[]
      },
    };
  },
  computed: {
    ...mapState(['user'])
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.$http.get('/student/pc/getSchoolInspectorList', { current: this.pageData.current, size: this.pageData.size }).then(res => {
        this.pageData = res
      })
    },
    toDetails(e) {
      this.$router.push({
        path: './msgDetails',
        query:{
          id:e.id
        }
      })
    },
    handleSizeChange(val) {
      this.pageData.size = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageData.current = val;
      this.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
.newMine_pageTitle {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
}

.newMine_content {
  min-height: 500px;
  padding: 0 30px;
}

.newMine_list {
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px dashed #ccc;

  .list_title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    flex: 1;
    margin-right: 30px;
  }

  .list_time {
    width: 170px;
  }
}

.newMine_list:hover {
  font-weight: 650;
  cursor: pointer;
}
</style>
